
import localforage from 'localforage'
import jwt_decode from 'jwt-decode'

import api from '../../assets/js/api-instance'

export default {
	state: {
		user_id: null,
		handle: null,
	},

	mutations: {
		user (state, payload) {
			state.user_id = payload.user_id;
			state.handle = payload.handle;
		}
	},
	
	actions: {
		async restore({ commit, rootState, dispatch }) {
			const jwt = await localforage.getItem("jwt");
			if (jwt) {
				commit('user', jwt_decode(jwt));
			} else {
				commit('user', {});
			}
			
// 			commit('tokens', await api.listTokens({}));
			await dispatch('fetchTokens');
		},
		
		async logout({ commit, dispatch }) {
			await api.logout();
			await dispatch('clearTokenStore');
			commit('user', {});
		}
	}
};
